<adapt-dismissible-cta [flag]="PersonFlag.CoachSessionDismissed"
                       [ctaStyle]="2">
    <h2 adapt-cta-title>Want to talk to our AI coach?</h2>

    <button adapt-cta-action
            class="btn btn-primary px-4"
            (click)="gotoCoachChatPage()">
        Talk to our AI coach
        <i class="fal fa-fw fa-arrow-right ms-2"></i>
    </button>

    <div>Get some answers to common problems, help with the platform and more.</div>
</adapt-dismissible-cta>
